module.exports = __webpack_public_path__ + "img/dash-04.b7f0c7a9.jpg";